export default __webpack_public_path__ + "static/media/wrong1-b.f3c24d13.png";